module.exports = __webpack_public_path__ + "img/MX.79f08d1a.png";